module.exports = __webpack_public_path__ + "static/media/exhaust-gas-sensor.3a56bdc9.svg";